import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTransition, animated, useSpring } from "@react-spring/web";
import cx from "classnames";
import styles from "./manageSource.module.scss";
import Slider from "../slider";
import Button from "../button";
import { createDataSourceMapping, deleteDataSourceMapping, fetchDataSource, fetchDataSourceChildren, fetchDataSourceMappings, syncDataSourceMapping } from "../../redux/actions/dataSource";
import { StreamDetail } from "../../pages/streams/types";
import dateFormat from "dateformat";
import { Col, Row } from "react-bootstrap";
import _ from "lodash";
import { ActionConfig } from ".";
import EmptyMessage from "../emptyMessage";
import { MappingsBrowser } from "./entityBrowser/entityBrowser";
import { useStreamsAdoption } from "src/redux/actions/adoption/streams";
import Toast from "../toast";
import { NavLink, useNavigate } from "react-router-dom";

interface MappingsProps {
  setCanRenderMappings: any;
  setCreateNewMapping: any;
  entityType: string;
  stream?: StreamDetail;
  group?: any;
  handleClose: () => void;
  setIsLoadingMappings: any;
}

const Mappings: React.FC<MappingsProps> = ({
  setCanRenderMappings, setCreateNewMapping, entityType, stream, group, handleClose, setIsLoadingMappings
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { trackConnectedSourceSelected, trackFolderSelected, trackConnectedSourcesViewed, trackSourceAdded } = useStreamsAdoption();

  const mappings = useSelector((state: any) => state.dataSource.items);

  const [selectedMapping, setSelectedMapping] = useState<any>(null);
  const [selectedFolder, setSelectedFolder] = useState<any>("");
  const [showConfirmAction, setShowConfirmAction] = useState(false);
  const [createMapping, setCreateMapping] = useState<any>({});
  const [selectedFolderName, setSelectedFolderName] = useState<string>("");
  const [authToast, setAuthToast] = useState<boolean>(false);
  const subTitleTransition = useTransition(true, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
  });
 const selectedMappingInfo = _.find(mappings,{id: selectedMapping})

  useEffect(() => {
    trackConnectedSourcesViewed();
  }, [])

  const handleCreateMapping = (file: any) => {
    setSelectedFolder(file.id);
    setSelectedFolderName(file.name);
    setShowConfirmAction(true);
    setCreateMapping(file);
    trackFolderSelected({ streamId: stream?.id, groupId: group?.id, folderName: file.name });
  }

  const onMappingSelection = (id: string) => {
    setSelectedMapping(id);
    trackConnectedSourceSelected({ streamId: stream?.id, groupId: group?.id });
  }

  const renderMappings = () => {
    return (
      <div className={styles.mappings}>
      <MappingsBrowser
        width={320}
        action={entity => {
          console.log("action", entity)
          return false;
        }}
        onMappingSelection={(id) => onMappingSelection(id)}
        onSelection={(file) =>  handleCreateMapping(file)}
        selectedFolder={selectedFolder}
        mappings={mappings}
        setAuthToast={setAuthToast}
      />
      </div>
    )
  }

  const handleConfirmClick = () => {
    setIsLoadingMappings(true)
    const newMapping = _.find(mappings, { id: selectedMapping });
    const newMappingPath = `/${selectedFolderName}`;

    const requestMapping = {
      folder: newMappingPath,
      externalFolderId: selectedFolder,
      dataSource: {
        id: newMapping.id,
        storageType: newMapping.storageType,
      }
    }

    const request = {
      ...requestMapping,
      target: {
        id: stream?.id || group.id,
        entityType: entityType
      }
    }

    dispatch(createDataSourceMapping({ source: selectedMapping, request, event: trackSourceAdded }))

    setCreateNewMapping(false);
    setCanRenderMappings(false);
    setShowConfirmAction(false);
    setSelectedFolder(null);
  }

  return (
    <>
      {subTitleTransition((style, item) =>
        item ? (
          <animated.div style={style} className={styles.header}>
            <Slider.Header title="">
              <h2 className={styles.title}>
                <span className={styles.backIcon}>
                  <i className="paperflite-left-arrow"
                    onClick={() => {
                      setCanRenderMappings(false)
                      setCreateNewMapping(false)
                      setSelectedMapping(null)
                      setShowConfirmAction(false)
                    }}>
                  </i>
                </span>
                <span>connected sources</span>
              </h2>
              <p className={styles.subTitle}>Connect a new source to keep the stream fresh—like 
              coffee on a Monday.</p>
            </Slider.Header>
          </animated.div>
        ) : null
      )}

      {_.size(mappings) === 0 && (
        <div className={styles.emptyContainer}>
          <EmptyMessage
            width={400}
            image={'/images/manageSources/empty_connected_sources.svg'}
            heading="No connections found. Let’s get them flying!"
            message=""
            action={{
              title: "Connect a source",
              icon: 'paperflite-plus',
              onClick: () => { navigate('/settings/data-sources') }
            }}
          />
        </div>
      )}

      {_.size(mappings) > 0 && renderMappings()}

      {
        authToast && (
          <Toast.warning
            heading="Authentication required"
            className={styles.authToast}
            closeToast={() => setAuthToast(false)}
            message={<span> Your authentication token to <span className={styles.storageName}>{selectedMappingInfo.name + " " +selectedMappingInfo.storageName} </span> content source has expired. Please re-authenticate to stay connected to your datasource
              <NavLink to="/settings/data-sources" className={styles.link}> Re-authenticate</NavLink>
            </span>}
          />
        )
      }
      {showConfirmAction && (
        <ActionConfig
          showConfirmAction={true}
          entityType={entityType}
          stream={stream}
          group={group}
          selectedFolder={createMapping}
          handleConfirmClick={handleConfirmClick}
          handleClose={handleClose}
        />
      )}
    </>
  )

}

export default Mappings;